export enum SvgIconsEnums {
  NOT_ELIGIBLE = 'not-eligible',
  POSSIBLE_DUPLICATE = 'possible-duplicate',
  XPO_PUBLISH = 'xpo-publish',
  XPO_TRASH = 'xpo-trash',
  FILE_CSV = 'file-csv',
  FILE_EXCEL = 'file-excel',
}
